import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class DomesticHotWaterTimeScheduleMonday implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES:
        ' 62 02 B3 01 05 1E 16 1E 00 00 03 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.DomesticHotWaterTimeScheduleMonday,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'DomesticHotWaterTimeScheduleMonday',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_Entri',
              unit: '',
              translationid: 'TI_Entries',
              dopname: '1 Byte Identical uint8',
              name: 'PA_Entri',
              value: '1',
            },
            {
              semantic: 'STARTSTOPTEMP',
              path: 'PA_DataRecor/PA_Array',
              translationid: 'TI_StartStopTemp',
              dopname: 'EOPF Structure StartStopTime',
              name: 'PA_Array',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '5',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '30',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '22',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '30',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '3',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime',
                  translationid: '',
                  dopname: '7 Byte Structure StartStopTime',
                  name: 'STR_7ByteStrucStartStopTime',
                  structure: [
                    {
                      semantic: 'STARTTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                      translationid: 'TI_StartTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StartTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'STOPTIME',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                      translationid: 'TI_StopTime',
                      dopname: '2 Byte Structure Time Short',
                      name: 'PA_StopTime',
                      structure: [
                        {
                          semantic: 'HOUR',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                          unit: 'h',
                          translationid: 'TI_Hour',
                          dopname: '1 Byte Identical uint8 Hour',
                          name: 'PA_Hour',
                          value: '0',
                        },
                        {
                          semantic: 'MINUTE',
                          path:
                            'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                          unit: 'min',
                          translationid: 'TI_Minute',
                          dopname: '1 Byte Identical uint8 Minute',
                          name: 'PA_Minut',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserTempe',
                      value: '0',
                    },
                    {
                      semantic: 'RESERVED',
                      path: 'PA_DataRecor/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                      unit: '',
                      translationid: '',
                      dopname: '',
                      name: 'PA_ReserMode',
                      value: '0',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 02 B3',
    };
  }
  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.DomesticHotWaterTimeScheduleMonday,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '691',
          value: 'DomesticHotWaterTimeScheduleMonday',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'STARTTIMECOMFORT',
              longname: 'StartTimeComfort',
              byteposition: '0',
              dopname: '2 Byte Structure Time Short PhysConstSixOClock',
              precision: '',
              byteLength: '-1',
              type: 'eSTRUCTURE',
              shortname: 'PA_StartTimeComfo',
              constraints: '',
              structure: [
                {
                  semantic: 'HOUR',
                  longname: 'Hour',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8 Hour',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Hour',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StartTimeComfo/PA_Hour',
                  unit: 'h',
                  translationid: 'TI_Hour',
                  bitposition: '0',
                  name: 'PA_Hour',
                  value: '6',
                },
                {
                  semantic: 'MINUTE',
                  longname: 'Minute',
                  byteposition: '1',
                  dopname: '1 Byte Identical uint8 Minute',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Minut',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StartTimeComfo/PA_Minut',
                  unit: 'min',
                  translationid: 'TI_Minute',
                  bitposition: '0',
                  name: 'PA_Minut',
                  value: '0',
                },
              ],
              path: 'PA_Value/PA_StartTimeComfo',
              unit: '',
              translationid: 'TI_StartTimeComfort',
              bitposition: '0',
              name: 'PA_StartTimeComfo',
              value: '2',
            },
            {
              semantic: 'STOPTIMECOMFORT',
              longname: 'StopTimeComfort',
              byteposition: '2',
              dopname: '2 Byte Structure Time Short PhysConstTwentyTwoOClock',
              precision: '',
              byteLength: '-1',
              type: 'eSTRUCTURE',
              shortname: 'PA_StopTimeComfo',
              constraints: '',
              structure: [
                {
                  semantic: 'HOUR',
                  longname: 'Hour',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8 Hour',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Hour',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StopTimeComfo/PA_Hour',
                  unit: 'h',
                  translationid: 'TI_Hour',
                  bitposition: '0',
                  name: 'PA_Hour',
                  value: '22',
                },
                {
                  semantic: 'MINUTE',
                  longname: 'Minute',
                  byteposition: '1',
                  dopname: '1 Byte Identical uint8 Minute',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Minut',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StopTimeComfo/PA_Minut',
                  unit: 'min',
                  translationid: 'TI_Minute',
                  bitposition: '0',
                  name: 'PA_Minut',
                  value: '0',
                },
              ],
              path: 'PA_Value/PA_StopTimeComfo',
              unit: '',
              translationid: 'TI_StopTimeComfort',
              bitposition: '0',
              name: 'PA_StopTimeComfo',
              value: '2',
            },
            {
              semantic: 'DEFLEVEL',
              longname: 'LevelComfort',
              byteposition: '4',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              precision: '1',
              byteLength: '16',
              type: 'eA_FLOAT32',
              shortname: 'PA_LevelComfo',
              constraints: '[-3276.8:3276.7]',
              path: 'PA_Value/PA_LevelComfo',
              unit: '°C',
              translationid: 'TI_LevelComfort',
              bitposition: '0',
              name: 'PA_LevelComfo',
              value: '20.0',
            },
            {
              semantic: 'VALUE',
              longname: 'ValueComfort',
              byteposition: '6',
              dopname: '1 Byte TextTable CentralHeatingTemperatureLevel',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_ValueComfo',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                {
                  TI_texttableentry: 'TI_FrostProtection',
                  interval: '1',
                  texttableentry: 'FrostProtection',
                },
                { TI_texttableentry: 'TI_Reduced', interval: '2', texttableentry: 'Reduced' },
                { TI_texttableentry: 'TI_Normal', interval: '3', texttableentry: 'Normal' },
                { TI_texttableentry: 'TI_Comfort', interval: '4', texttableentry: 'Comfort' },
              ],
              path: 'PA_Value/PA_ValueComfo',
              unit: '',
              translationid: 'TI_ValueComfort',
              bitposition: '0',
              name: 'PA_ValueComfo',
              value: 'Comfort',
            },
            {
              semantic: 'STARTTIMEREDUCED',
              longname: 'StartTimeReduced',
              byteposition: '7',
              dopname: '2 Byte Structure Time Short PhysConstTwentyTwoOClock',
              precision: '',
              byteLength: '-1',
              type: 'eSTRUCTURE',
              shortname: 'PA_StartTimeReduc',
              constraints: '',
              structure: [
                {
                  semantic: 'HOUR',
                  longname: 'Hour',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8 Hour',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Hour',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StartTimeReduc/PA_Hour',
                  unit: 'h',
                  translationid: 'TI_Hour',
                  bitposition: '0',
                  name: 'PA_Hour',
                  value: '22',
                },
                {
                  semantic: 'MINUTE',
                  longname: 'Minute',
                  byteposition: '1',
                  dopname: '1 Byte Identical uint8 Minute',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Minut',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StartTimeReduc/PA_Minut',
                  unit: 'min',
                  translationid: 'TI_Minute',
                  bitposition: '0',
                  name: 'PA_Minut',
                  value: '0',
                },
              ],
              path: 'PA_Value/PA_StartTimeReduc',
              unit: '',
              translationid: 'TI_StartTimeReduced',
              bitposition: '0',
              name: 'PA_StartTimeReduc',
              value: '2',
            },
            {
              semantic: 'STOPTIMEREDUCED',
              longname: 'StopTimeReduced',
              byteposition: '9',
              dopname: '2 Byte Structure Time Short PhysConstSixOClock',
              precision: '',
              byteLength: '-1',
              type: 'eSTRUCTURE',
              shortname: 'PA_StopTimeReduc',
              constraints: '',
              structure: [
                {
                  semantic: 'HOUR',
                  longname: 'Hour',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8 Hour',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Hour',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StopTimeReduc/PA_Hour',
                  unit: 'h',
                  translationid: 'TI_Hour',
                  bitposition: '0',
                  name: 'PA_Hour',
                  value: '6',
                },
                {
                  semantic: 'MINUTE',
                  longname: 'Minute',
                  byteposition: '1',
                  dopname: '1 Byte Identical uint8 Minute',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Minut',
                  constraints: '[0:255]',
                  path: 'PA_Value/PA_StopTimeReduc/PA_Minut',
                  unit: 'min',
                  translationid: 'TI_Minute',
                  bitposition: '0',
                  name: 'PA_Minut',
                  value: '0',
                },
              ],
              path: 'PA_Value/PA_StopTimeReduc',
              unit: '',
              translationid: 'TI_StopTimeReduced',
              bitposition: '0',
              name: 'PA_StopTimeReduc',
              value: '2',
            },
            {
              semantic: 'DEFLEVEL',
              longname: 'LevelReduced',
              byteposition: '11',
              dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
              precision: '1',
              byteLength: '16',
              type: 'eA_FLOAT32',
              shortname: 'PA_LevelReduc',
              constraints: '[-3276.8:3276.7]',
              path: 'PA_Value/PA_LevelReduc',
              unit: '°C',
              translationid: 'TI_LevelReduced',
              bitposition: '0',
              name: 'PA_LevelReduc',
              value: '17.0',
            },
            {
              semantic: 'VALUE',
              longname: 'ValueReduced',
              byteposition: '13',
              dopname: '1 Byte TextTable CentralHeatingTemperatureLevel',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_ValueReduc',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                {
                  TI_texttableentry: 'TI_FrostProtection',
                  interval: '1',
                  texttableentry: 'FrostProtection',
                },
                { TI_texttableentry: 'TI_Reduced', interval: '2', texttableentry: 'Reduced' },
                { TI_texttableentry: 'TI_Normal', interval: '3', texttableentry: 'Normal' },
                { TI_texttableentry: 'TI_Comfort', interval: '4', texttableentry: 'Comfort' },
              ],
              path: 'PA_Value/PA_ValueReduc',
              unit: '',
              translationid: 'TI_ValueReduced',
              bitposition: '0',
              name: 'PA_ValueReduc',
              value: 'Reduced',
            },
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '14',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'True',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }
  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.DomesticHotWaterTimeScheduleMonday,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '691',
              value: 'DomesticHotWaterTimeScheduleMonday',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ENTRIES',
                  longname: 'Entries',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_Entri',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_Entri',
                  unit: '',
                  translationid: 'TI_Entries',
                  bitposition: '0',
                  name: 'PA_Entri',
                  value: '0',
                },
                {
                  semantic: 'STARTSTOPTEMP',
                  longname: 'Array',
                  byteposition: '1',
                  dopname: 'EOPF Structure StartStopTime',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_Array',
                  constraints: '[8:8]',
                  structure: [
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                    {
                      semantic: '',
                      longname: '7 Byte Structure StartStopTime',
                      byteposition: '-1',
                      dopname: '7 Byte Structure StartStopTime',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_7ByteStrucStartStopTime',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'STARTTIME',
                          longname: 'StartTime',
                          byteposition: '0',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StartTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StartTime',
                          unit: '',
                          translationid: 'TI_StartTime',
                          bitposition: '0',
                          name: 'PA_StartTime',
                          value: '2',
                        },
                        {
                          semantic: 'STOPTIME',
                          longname: 'StopTime',
                          byteposition: '2',
                          dopname: '2 Byte Structure Time Short',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_StopTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'HOUR',
                              longname: 'Hour',
                              byteposition: '0',
                              dopname: '1 Byte Identical uint8 Hour',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Hour',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              bitposition: '0',
                              name: 'PA_Hour',
                              value: '0',
                            },
                            {
                              semantic: 'MINUTE',
                              longname: 'Minute',
                              byteposition: '1',
                              dopname: '1 Byte Identical uint8 Minute',
                              precision: '',
                              byteLength: '8',
                              type: 'eA_UINT32',
                              shortname: 'PA_Minut',
                              constraints: '[0:255]',
                              path:
                                'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              bitposition: '0',
                              name: 'PA_Minut',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_StopTime',
                          unit: '',
                          translationid: 'TI_StopTime',
                          bitposition: '0',
                          name: 'PA_StopTime',
                          value: '2',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedTemperature',
                          byteposition: '4',
                          dopname: '',
                          precision: '',
                          byteLength: '16',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserTempe',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserTempe',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserTempe',
                          value: '0',
                        },
                        {
                          semantic: 'RESERVED',
                          longname: 'ReservedMode',
                          byteposition: '6',
                          dopname: '',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_ReserMode',
                          constraints: '',
                          path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime/PA_ReserMode',
                          unit: '',
                          translationid: '',
                          bitposition: '0',
                          name: 'PA_ReserMode',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_Array/STR_7ByteStrucStartStopTime',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_7ByteStrucStartStopTime',
                      value: '4',
                    },
                  ],
                  path: 'PA_Struc/PA_Array',
                  unit: '',
                  translationid: 'TI_StartStopTemp',
                  bitposition: '0',
                  name: 'PA_Array',
                  value: '1',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
